module.exports = __webpack_public_path__ + "img/alarmClock.6edf0012.svg";